// @ts-nocheck
import React, { useState } from 'react';
import '../styles/PriceListSection.css';

// Fallback JSX intrinsic elements typing to satisfy TypeScript when React JSX types are not picked up
declare global {
  namespace JSX {
    interface IntrinsicElements {
      [elemName: string]: any;
    }
  }
}

const PriceListSection: React.FC = () => {
  const [activeLocation, setActiveLocation] = useState<'location1' | 'location2'>('location1');

  return (
    <section className="pricelist-section">
      <h2>Árlista</h2>
      
      <div className="location-selector">
        <button 
          className={`location-btn ${activeLocation === 'location1' ? 'active' : ''}`}
          onClick={() => setActiveLocation('location1')}
        >
          NailsRoom
        </button>
        <button 
          className={`location-btn ${activeLocation === 'location2' ? 'active' : ''}`}
          onClick={() => setActiveLocation('location2')}
        >
          Teola Salon
        </button>
      </div>

      <div className={`price-list ${activeLocation === 'location1' ? 'active' : ''}`}>
        <h3>NailsRoomban elérhető szolgáltatások és árak</h3>
        <div className="service-groups">
          <div className="service-group">
            <h4>Pedikűr</h4>
            <div className="price-items">
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">SUBtitan system körömszabályzás</span>
                  <span className="price">16 000 Ft/db</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Gél lakk eltávolítás (más munkája) új szett esetén</span>
                  <span className="price">2 000 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Gél lakk /egyszínű/</span>
                  <span className="price">9 000 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Díszítés</span>
                  <span className="price">350 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Gél lakk /francia/</span>
                  <span className="price">9 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Gél lakk eltávolítás</span>
                  <span className="price">7 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Körömlakk eltávolítás</span>
                  <span className="price">1 200 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Szikés pedikűr körömformázással</span>
                  <span className="price">10 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Gyümölcssavas hámlasztással, pedikűr, körömformázással</span>
                  <span className="price">11 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Kombinált pedikűr körömformázással</span>
                  <span className="price">13 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Pedikűr fiatalkorúaknak /14-18 évesig/</span>
                  <span className="price">7 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Körömformázás mini pedivel</span>
                  <span className="price">6 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Körömformázás /14-18 évesig/</span>
                  <span className="price">4 800 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Benőtt köröm eltávolítása</span>
                  <span className="price">7 500 Ft/ujj</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Tyúkszem eltávolítása</span>
                  <span className="price">3 000 Ft/db</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Gombás köröm kezelése</span>
                  <span className="price">5 500 Ft/köröm</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Körömszabályozás</span>
                  <span className="price">15 000 Ft/db</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Körömprotézis</span>
                  <span className="price">5 500 Ft/db</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Tanácsadás</span>
                  <span className="price">5 000 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Masszázs</span>
                  <span className="price">5 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Parrafinos lábápolás mini pedivel</span>
                  <span className="price">7 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">NailsRoomSpa</span>
                  <span className="price">22 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Hagyományos pedikűr gél lakkal</span>
                  <span className="price">16 000 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Gyümölcssavas pedikűr gél lakkal</span>
                  <span className="price">17 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Kombinált pedikűr gél lakkal</span>
                  <span className="price">18 500 Ft</span>
                </div>
              </div>
            </div>
          </div>

          <div className="service-group">
            <h4>Manikűr</h4>
            <div className="price-items">
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Gél lakk</span>
                  <span className="price">9 000 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Gél lakk francia</span>
                  <span className="price">9 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Töltés</span>
                  <span className="price">10 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Töltés francia</span>
                  <span className="price">11 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Építés</span>
                  <span className="price">12 000 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Japán manikűr</span>
                  <span className="price">5 500 Ft</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`price-list ${activeLocation === 'location2' ? 'active' : ''}`}>
        <h3>Teola Salonban elérhető szolgáltatások és árak</h3>
        <div className="service-groups">
          <div className="service-group">
            <h4>Pedikűr</h4>         
           
            <div className="price-items">
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">SUBtitan system körömszabályzás</span>
                  <span className="price">16 000 Ft/db</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Gél lakk eltávolítás (más munkája) új szett esetén</span>
                  <span className="price">2 000 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Gél lakk /egyszínű/</span>
                  <span className="price">9 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Díszítés</span>
                  <span className="price">350 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Gél lakk /francia/</span>
                  <span className="price">10 000 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Gél lakk eltávolítás</span>
                  <span className="price">7 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Körömlakk eltávolítás</span>
                  <span className="price">1 200 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Szikés pedikűr körömformázással</span>
                  <span className="price">10 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Gyümölcssavas hámlasztással, pedikűr, körömformázással</span>
                  <span className="price">11 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Kombinált pedikűr körömformázással</span>
                  <span className="price">13 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Pedikűr fiatalkorúaknak /14-18 évesig/</span>
                  <span className="price">8 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Körömformázás mini pedivel</span>
                  <span className="price">6 800 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Körömformázás /14-18 évesig/</span>
                  <span className="price">4 200 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Benőtt köröm eltávolítása</span>
                  <span className="price">7 000 Ft/ujj</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Tyúkszem eltávolítása</span>
                  <span className="price">3 000 Ft/db</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Gombás köröm kezelése</span>
                  <span className="price">5 000 Ft/köröm</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Körömszabályozás</span>
                  <span className="price">15 000 Ft/db</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Körömprotézis</span>
                  <span className="price">5 500 Ft/db</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Tanácsadás</span>
                  <span className="price">4 000 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Masszázs</span>
                  <span className="price">5 500 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Parrafinos lábápolás mini pedivel</span>
                  <span className="price">7 000 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Hagyományos pedikűr gél lakkal</span>
                  <span className="price">16 000 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Gyümölcssavas pedikűr gél lakkal</span>
                  <span className="price">17 000 Ft</span>
                </div>
              </div>
              <div className="price-item">
                <div className="price-item-header">
                  <span className="service">Kombinált pedikűr gél lakkal</span>
                  <span className="price">18 500 Ft</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PriceListSection; 